const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorderdtl/update', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
